/**
 * Toast notification utilities
 * Based on 001a-Extension.md specifications
 * 
 * Uses Sonner (shadcn/ui) with custom styling for:
 * - Success (green #10B981)
 * - Error (red #EF4444)
 * - Info (ink #0F172A)
 * - Warning (orange #F59E0B)
 */

import { toast } from 'sonner'

const TOAST_DURATION = 4000 // 4 seconds as per spec

/**
 * Show success toast
 * Green background, white text, checkmark icon
 */
export function showSuccessToast(message: string) {
  return toast.success(message, {
    duration: TOAST_DURATION,
    className: 'bg-green-500 text-white border-green-600',
    style: {
      backgroundColor: '#10B981',
      color: 'white',
      border: 'none',
    },
  })
}

/**
 * Show error toast
 * Red background, white text, warning icon
 */
export function showErrorToast(message: string) {
  return toast.error(message, {
    duration: TOAST_DURATION,
    className: 'bg-red-500 text-white border-red-600',
    style: {
      backgroundColor: '#EF4444',
      color: 'white',
      border: 'none',
    },
  })
}

/**
 * Show info toast
 * Ink background, white text, info icon
 */
export function showInfoToast(message: string) {
  return toast.info(message, {
    duration: TOAST_DURATION,
    className: 'bg-slate-900 text-white border-slate-800',
    style: {
      backgroundColor: '#0F172A',
      color: 'white',
      border: 'none',
    },
  })
}

/**
 * Show warning toast
 * Orange background, white text, warning icon
 */
export function showWarningToast(message: string) {
  return toast.warning(message, {
    duration: TOAST_DURATION,
    className: 'bg-orange-500 text-white border-orange-600',
    style: {
      backgroundColor: '#F59E0B',
      color: 'white',
      border: 'none',
    },
  })
}

/**
 * Show custom toast with custom styling
 */
export function showToast(message: string, options?: Parameters<typeof toast>[1]) {
  return toast(message, {
    duration: TOAST_DURATION,
    ...options,
  })
}
